import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function CookieConsent() {
  const location = useLocation();

  useEffect(() => {
    const script = document.createElement("script");
    script.id = "cookieyes";
    script.type = "text/javascript";
    script.src = "https://cdn-cookieyes.com/client_data/8f6f3d881f12864f4e6f74b9/script.js";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, [location.pathname]); // Re-run on route change

  return null;
}

export default CookieConsent;
